import { elanTemplateToConfig } from "./elanTemplate";

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/** "Import ELAN template" beside Browse Templates in the labeling setup: an
 *  ELAN template (.etf) or annotation file (.eaf) becomes a <VideoTiers>
 *  config with its tier types, controlled vocabularies and tiers. */
export const elanConfigImport = {
  id: "elan",
  label: "Import ELAN template",
  tooltip:
    "Build the labeling config from an ELAN template (.etf) or .eaf file: its tier types, controlled vocabularies and tiers",
  accept: ".etf,.eaf,application/xml,text/xml",
  toConfig(text: string, name: string) {
    const out = elanTemplateToConfig(text);
    return {
      config: out.config,
      message:
        `Imported ${name}: ${plural(out.tiers, "tier", "tiers")}, ${plural(out.types, "tier type", "tier types")}, ` +
        `${plural(out.vocabularies, "vocabulary", "vocabularies")}. The video comes from the task's "video" field.`,
    };
  },
};
